"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decoder = void 0;
const Delta_1 = require("../../Delta");
const json_crdt_patch_1 = require("../../../../json-crdt-patch");
const Decoder_1 = require("../../../../json-crdt-patch/batch/codec/binary/Decoder");
class Decoder extends Decoder_1.Decoder {
    decodeDelta(data) {
        this.reader.reset(data);
        return this.readDelta();
    }
    readDelta() {
        const meta = this.val();
        const reader = this.reader;
        const vv0 = json_crdt_patch_1.ClockVector.from(reader.vv());
        const vv1 = json_crdt_patch_1.ClockVector.from(reader.vv());
        const batch = this.readBatch();
        const delta = new Delta_1.Delta(vv0, vv1, batch);
        delta.meta = meta;
        return delta;
    }
}
exports.Decoder = Decoder;
